var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import store from '../store/store';
import { setAuth, logout } from '../store/authSlice';
const URL = [
    'http://localhost:9000/api',
    'https://taskmaster-backend-e940.onrender.com/api',
];
const currentURL = 1;
const api = axios.create({
    baseURL: URL[currentURL],
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});
let isRefreshing = false;
let failedQueue = [];
const processQueue = (error, token = null) => {
    if (token !== null) {
        failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve(token)));
    }
    failedQueue = [];
};
api.interceptors.request.use((config) => {
    var _a;
    const token = (_a = store.getState().auth) === null || _a === void 0 ? void 0 : _a.accessToken;
    if (token)
        config.headers['Authorization'] = `Bearer ${token}`;
    return config;
}, (error) => Promise.reject(error));
api.interceptors.response.use((response) => response, (error) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const originalRequest = error.config;
    if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && !originalRequest._retry) {
        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                failedQueue.push({ resolve, reject });
            }).then((token) => {
                var _a;
                originalRequest._retry = true;
                originalRequest.headers = (_a = originalRequest.headers) !== null && _a !== void 0 ? _a : {};
                originalRequest.headers['Authorization'] = `Bearer ${token}`;
                return api(originalRequest);
            });
        }
        originalRequest._retry = true;
        isRefreshing = true;
        try {
            const refreshRes = yield axios.post(`${URL[currentURL]}/auth/refresh`, {}, { withCredentials: true });
            const newAccessToken = refreshRes.data.data;
            store.dispatch(setAuth(Object.assign(Object.assign({}, store.getState().auth), { accessToken: newAccessToken })));
            processQueue(null, newAccessToken);
            originalRequest.headers = (_b = originalRequest.headers) !== null && _b !== void 0 ? _b : {};
            originalRequest.headers['Authorization'] =
                `Bearer ${newAccessToken}`;
            return api(originalRequest);
        }
        catch (err) {
            processQueue(err, null);
            store.dispatch(logout());
            window.location.replace('/login');
            return Promise.reject(err);
        }
        finally {
            isRefreshing = false;
        }
    }
    return Promise.reject(error);
}));
export default api;
